import { Controller } from "@hotwired/stimulus"
import { reviewRows, reviewRules } from "../modules/product_wizard.mjs"
import { ruleSentence } from "../modules/product_options.mjs"

// Paso Revisión: filas con "Editar" y reglas por grupo desde product-wizard:state; al conectar pide un refresh.
// Doc: _docs/features/products/partner_product_form.md
export default class extends Controller {
  static targets = ["productValue", "productSub", "priceValue", "priceSub", "optionsValue", "optionsSub", "rules", "rulesList"]

  connect() {
    const wizard = this.element.closest("[data-controller~='product-wizard']")
    const controller = wizard && this.application.getControllerForElementAndIdentifier(wizard, "product-wizard")
    controller?.refresh()
  }

  render(event) {
    const state = event.detail?.state
    if (!state) return
    const rows = reviewRows(state)
    this.#text(this.productValueTarget, rows.product.value)
    this.#text(this.productSubTarget, rows.product.sub)
    this.#text(this.priceValueTarget, rows.price.value)
    this.#text(this.priceSubTarget, rows.price.sub)
    this.#text(this.optionsValueTarget, rows.options.value)
    this.#text(this.optionsSubTarget, rows.options.sub)
    this.#renderRules(reviewRules(state, group => ruleSentence(
      { selected: group.alternatives.length, max: group.max, required: group.required, repeat: group.repeat },
      { priced: group.alternatives.some(alternative => alternative.price > 0) }
    )))
  }

  #renderRules(rules) {
    const key = JSON.stringify(rules)
    if (this.rulesKey === key) return
    this.rulesKey = key
    this.rulesTarget.hidden = rules.length === 0
    this.rulesListTarget.replaceChildren(...rules.map(rule => {
      const item = document.createElement("li")
      item.className = "review-rules__item"
      const icon = document.createElement("i")
      icon.className = "bi bi-check-lg review-rules__check"
      icon.setAttribute("aria-hidden", "true")
      // Nombre y frase en un solo span (con flex el texto se partiría)
      const text = document.createElement("span")
      const name = document.createElement("strong")
      name.textContent = `${rule.name}: `
      text.append(name, document.createTextNode(rule.sentence))
      item.append(icon, text)
      return item
    }))
  }

  #text(element, value) {
    if (element.textContent !== value) element.textContent = value
  }
}
